/**
 * Ids for mutations and client-side keys.
 *
 * `crypto.randomUUID` only exists in a secure context: over plain http on a LAN
 * or Tailscale address (`http://192.168.1.5:8080`) it is undefined, and calling
 * it throws — which used to break every command the UI sends. `getRandomValues`
 * has no such restriction, so fall back to a v4 built from it.
 */
export function uuid() {
    const c = globalThis.crypto;
    if (typeof c?.randomUUID === "function")
        return c.randomUUID();
    const b = new Uint8Array(16);
    if (typeof c?.getRandomValues === "function")
        c.getRandomValues(b);
    else
        for (let i = 0; i < 16; i++)
            b[i] = Math.floor(Math.random() * 256);
    b[6] = (b[6] & 0x0f) | 0x40; // version 4
    b[8] = (b[8] & 0x3f) | 0x80; // variant 1
    const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
//# sourceMappingURL=ids.js.map